// redux_files/inventory/unitsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../utils/axiosAuth";

export const fetchUnits = createAsyncThunk(
  "units/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/get_uoms`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const unitsSlice = createSlice({
  name: "units",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnits.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUnits.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchUnits.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default unitsSlice.reducer;

export const selectUnitsRows = (state) => state.units.rows;
export const selectUnitsStatus = (state) => state.units.status;
export const selectUnitsError = (state) => state.units.error;
